/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const WindowSolidV6 = (props) => (
  <Icon {...props} name="Window Solid V6">
    <path d="M16 13c0 1.103-.897 2-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10zM3 5a1 1 0 1 0 .002-1.998A1 1 0 0 0 3 5zm3-2a1 1 0 1 0 0 2 1 1 0 1 0 0-2zm3 2a1 1 0 1 0 0-2 1 1 0 1 0 0 2z" />
  </Icon>
);

export default WindowSolidV6;
